import { useEffect, useState } from "react";
import { Articles } from "./pages/Articles/Articles";
import { Contacts } from "./pages/Contacts/Contacts";
import { Dharma } from "./pages/Dharma/Dharma";
import { NotFound } from "./pages/NotFound/NotFound";
import { Zins } from "./pages/Zins/Zins";

const getNavigationItem = (label = "", path = "", component = NotFound, subItems = [], href = path) =>
    ({ label, path, href, component, subItems })


const staticNavigationData = [
    getNavigationItem("Dharma", "/dharma", <Dharma />),
    getNavigationItem("Связаться", "/contacts", <Contacts />),
    getNavigationItem("Статьи", "/articles", <Articles />),
    getNavigationItem("Зины", "/zins", <Zins />),
]

export const useNavigationData = () => {
    const [navigationData, setNavData] = useState([])

    useEffect(() => {
        createNavigationData()
    }, [])

    const createNavigationData = () => {
        setNavData(staticNavigationData)
    }

    return navigationData
}